/**
 * Whether a premise's television should fetch the TV feeds at all.
 *
 * There used to be two adapters here as well, narrowing the real feeds into
 * "menu view" shapes. They are gone, and the reason is worth keeping: the
 * screens fetched the real feeds separately, so a room polled twice for one
 * answer — and wherever the router already HELD the data (the design preview,
 * most obviously) the menu knew a section existed while the section itself
 * rendered nothing. `SchemeRouter` now hands the whole feed down and the
 * screens read it, so the count the content gate makes is a read over the same
 * object the page draws.
 */

/**
 * Should this premise's television fetch a feed at all?
 *
 * The `has()` guard is not optional and not defensive style. `knobs.toggle()`
 * fails VISIBLE - an undeclared knob id reads as ON - so a naive read would
 * start every care premise polling a hotel film catalogue it declares no knob
 * for and is forbidden to have. This is the same guard `offersFeedWanted` and
 * `castingOn` need, for the same reason, and it has already shipped as a bug
 * twice (`showCast` in care rooms, Wi-Fi on atelier).
 */
export function tvFeedWanted(
  base: {
    knobs: { has: (id: string) => boolean; toggle: (id: string) => boolean };
  },
  toggleId: "showVod" | "showGuide"
): boolean {
  return base.knobs.has(toggleId) && base.knobs.toggle(toggleId);
}
